document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      new Swiper('.testimonial-slider .swiper', {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.testimonial-slider .swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      });
    }
  });